
/*global define*/

define('services/WizardServices',[
    'app',
    'jquery',
    //'underscore',
    'backbone'
], function(app, $, Backbone) {
    'use strict';

    var WizardServices = Backbone.Model.extend({

        token: '',

        initialize: function() {

            this.serviceURL = [];
            //window.BticinoS4B.baseUrl = '';
            // region LANGUAGES/LOCALIZATION
            this.serviceURL.setCurrentLocalizationURL        = window.BticinoS4B.baseUrl + 'WizardService.svc/setCurrentLocalization';
            this.serviceURL.setCurrentLanguageURL            = window.BticinoS4B.baseUrl + 'WizardService.svc/setCurrentLanguage';
            this.serviceURL.getLanguageListURL               = window.BticinoS4B.baseUrl + 'WizardService.svc/getLanguageList';
            this.serviceURL.getLanguageListByLocalizationURL = window.BticinoS4B.baseUrl + 'WizardService.svc/getLanguageListByLocalization';
            this.serviceURL.getExtendedLanguageListURL       = window.BticinoS4B.baseUrl + 'WizardService.svc/getExtendedLanguageList';
            this.serviceURL.setLocalizationLanguageURL       = window.BticinoS4B.baseUrl + 'WizardService.svc/setLocalizationLanguage';
            this.serviceURL.getDictionaryURL                 = window.BticinoS4B.baseUrl + 'WizardService.svc/getDictionary';

            // region AUTHENTICATION / USER MANAGEMENT
            this.serviceURL.loginURL                  = window.BticinoS4B.baseUrl + 'WizardService.svc/login';
            this.serviceURL.loginSSOURL               = window.BticinoS4B.baseUrl + 'WizardService.svc/loginSSO';
            this.serviceURL.loginByTokenURL           = window.BticinoS4B.baseUrl + 'WizardService.svc/loginByToken';
            this.serviceURL.logoutURL                 = window.BticinoS4B.baseUrl + 'WizardService.svc/logout';
            this.serviceURL.getUserURL                = window.BticinoS4B.baseUrl + 'WizardService.svc/getUser';
            this.serviceURL.getUsersByLocalizationURL = window.BticinoS4B.baseUrl + 'WizardService.svc/getUsersByLocalization';
            this.serviceURL.setUserURL                = window.BticinoS4B.baseUrl + 'WizardService.svc/setUser';

            // region PRODUCT RETRIEVAL/OPTIMIZATION
            this.serviceURL.getCatalogueByBranchURL                               = window.BticinoS4B.baseUrl + 'WizardService.svc/getCatalogueByBranch';
            this.serviceURL.setCatalogueByBranchURL                               = window.BticinoS4B.baseUrl + 'WizardService.svc/setCatalogueByBranch';
            this.serviceURL.getAccessoryLinesURL                                  = window.BticinoS4B.baseUrl + 'WizardService.svc/getAccessoryLines';
            this.serviceURL.getAllAccessoryLinesURL                               = window.BticinoS4B.baseUrl + 'WizardService.svc/getAllAccessoryLines';
            this.serviceURL.setAccessoryLinesByLocalizationURL                    = window.BticinoS4B.baseUrl + 'WizardService.svc/setAccessoryLinesByLocalization';
            this.serviceURL.getPackagesByLocalizationURL                          = window.BticinoS4B.baseUrl + 'WizardService.svc/getPackagesByLocalization';
            this.serviceURL.getPackagesByIdWizardChoiceURL                        = window.BticinoS4B.baseUrl + 'WizardService.svc/getPackagesByIdWizardChoice';
            this.serviceURL.getPackagesByIdWizardChoiceRegardlessAccessoryLineURL = window.BticinoS4B.baseUrl + 'WizardService.svc/getPackagesByIdWizardChoiceRegardlessAccessoryLine';
            this.serviceURL.getPackageByIdPackageClassURL                         = window.BticinoS4B.baseUrl + 'WizardService.svc/getPackageByIdPackageClass';
            this.serviceURL.getProductsURL                                        = window.BticinoS4B.baseUrl + 'WizardService.svc/getProducts';
            this.serviceURL.getProductsByIdPackageClassURL                        = window.BticinoS4B.baseUrl + 'WizardService.svc/getProductsByIdPackageClass';
            this.serviceURL.getOptionalPackagesBySystemIdURL                      = window.BticinoS4B.baseUrl + 'WizardService.svc/getOptionalPackagesBySystemId';
            this.serviceURL.getPackagesByPackageActuatorIdURL                     = window.BticinoS4B.baseUrl + 'WizardService.svc/getPackagesByPackageActuatorId';
            this.serviceURL.getOptimizedItemListURL                               = window.BticinoS4B.baseUrl + 'WizardService.svc/getOptimizedItemList';
            this.serviceURL.setPackageClassAccessoryLineLocalizationURL           = window.BticinoS4B.baseUrl + 'WizardService.svc/setPackageClassAccessoryLineLocalization';

            // region USER DOCUMENT MANAGEMENT
            this.serviceURL.getProjectListURL      = window.BticinoS4B.baseUrl + 'WizardService.svc/getProjectList';
            this.serviceURL.getGroupProjectListURL = window.BticinoS4B.baseUrl + 'WizardService.svc/getGroupProjectList';
            this.serviceURL.loadProjectURL         = window.BticinoS4B.baseUrl + 'WizardService.svc/loadProject';
            this.serviceURL.updateProjectURL       = window.BticinoS4B.baseUrl + 'WizardService.svc/updateProject';
            this.serviceURL.saveProjectURL         = window.BticinoS4B.baseUrl + 'WizardService.svc/saveProject';
            this.serviceURL.deleteProjectURL       = window.BticinoS4B.baseUrl + 'WizardService.svc/deleteProject';
            this.serviceURL.duplicateProjectURL    = window.BticinoS4B.baseUrl + 'WizardService.svc/duplicateProject';

            // region CATEGORYSYSTEM
            this.serviceURL.getAllCategorySystemListURL                   = window.BticinoS4B.baseUrl + 'WizardService.svc/getAllCategorySystemList';
            this.serviceURL.getEnabledCategorySystemListByLocalizationURL = window.BticinoS4B.baseUrl + 'WizardService.svc/getEnabledCategorySystemListByLocalization';
            this.serviceURL.setCategorySystemByLocalizationURL            = window.BticinoS4B.baseUrl + 'WizardService.svc/setCategorySystemByLocalization';

            // region PRICELIST
            this.serviceURL.getAllPriceListURL = window.BticinoS4B.baseUrl + 'WizardService.svc/getAllPriceList';
            this.serviceURL.getPriceListByLocalizationURL = window.BticinoS4B.baseUrl + 'WizardService.svc/getPriceListByLocalization';
            this.serviceURL.getPriceListItemsURL = window.BticinoS4B.baseUrl + 'WizardService.svc/getPriceListItems';
            this.serviceURL.publicPriceListURL = window.BticinoS4B.baseUrl + 'WizardService.svc/publicPriceList';

            // region FILE UPLOAD/DOWNLOAD
            this.serviceURL.uploadPriceListURL = window.BticinoS4B.baseUrl + 'WizardService.svc/uploadPriceList';
            this.serviceURL.importPriceListURL = window.BticinoS4B.baseUrl + 'WizardService.svc/importPriceList';
            this.serviceURL.downloadEmptyTemplatePriceListURL = window.BticinoS4B.baseUrl + 'WizardService.svc/downloadEmptyTemplatePriceList';
            this.serviceURL.downloadFullTemplatePriceListURL = window.BticinoS4B.baseUrl + 'WizardService.svc/downloadFullTemplatePriceList';

            // region MAIL
            this.serviceURL.ForwardProjectByEmailURL = window.BticinoS4B.baseUrl + 'WizardService.svc/ForwardProjectByEmail';

            app.calls = [];
        },

        startServerCall: function(async, callVar, url, callData, _successCallback, _successCallbackParameters, _successCallbackScope, _errorCallback, _errorCallbackParameters, _errorCallbackScope) {
            //Decalre default error's callback
            var successCallback = function(successData) {
                //console.log(successData.d);
            },
                errorCallback = function(jqXHR, textStatus, errorThrown) {
                    if (textStatus !== 'abort' && console) {
                        console.log('ERROR', jqXHR, textStatus, errorThrown);
                    }
                },
                successCallbackParameters = {},
                errorCallbackParameters = {},
                successCallbackScope = this,
                errorCallbackScope = this,
                ajaxParameters = {},
                BticinoS4B = app;

            if (url && callData) {
                if (_successCallback) {
                    successCallback = _successCallback;
                }

                if (_successCallbackParameters) {
                    successCallbackParameters = _successCallbackParameters;
                }

                if (_successCallbackScope) {
                    successCallbackScope = _successCallbackScope;
                }

                if (_errorCallback) {
                    errorCallback = _errorCallback;
                }

                if (_errorCallbackParameters) {
                    errorCallbackParameters = _errorCallbackParameters;
                }

                if (_errorCallbackScope) {
                    errorCallbackScope = _errorCallbackScope;
                }

                ajaxParameters = {
                    type: 'POST',
                    datatype: 'json',
                    contentType: 'application/json',
                    url: url,
                    async: async,
                    data: JSON.stringify(callData),
                    success: function(successData) {
                        if (callVar !== null) {
                            if (!window.BticinoS4B.cachedCalls[callVar]) {
                                window.BticinoS4B.cachedCalls[callVar] = [];
                            }
                            window.BticinoS4B.cachedCalls[callVar].push({data: callData, result: successData});
                        }
                        successCallback.apply(successCallbackScope, [successData, successCallbackParameters]);
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        errorCallback.apply(errorCallbackScope, [jqXHR, textStatus, errorThrown, errorCallbackParameters]);
                    }
                };
                
                var callFind = false;

                //if (callVar !== null) {
                if (false) {
                    if (window.BticinoS4B.cachedCalls[callVar]) {
                        
                        for(var i = 0; i < window.BticinoS4B.cachedCalls[callVar].length; i++){
                            if (JSON.stringify(window.BticinoS4B.cachedCalls[callVar][i].data) == JSON.stringify(callData)) {
                                callFind = true;
                                successCallback.apply(successCallbackScope, [window.BticinoS4B.cachedCalls[callVar][i].result, successCallbackParameters]);
                                console.log('cache call' + callVar);
                            }
                        }
                    }
                    if (!callFind) {
                        $.ajax(ajaxParameters);
                    }
                } else {
                    $.ajax(ajaxParameters);
                }
            }
        },

        getProducts: function(currentPackage, accessoryLineId, successCallback, successCallbackParameters, successCallbackScope) {
            if (currentPackage) {
                var packagesToFetch = (!(currentPackage instanceof Array)) ? [currentPackage] : currentPackage,
                    numberOfArticlesFetched = 0,
                    prepareDatasAndUpdateRaceCondition = function(serverData, originalPackage) {
                        numberOfArticlesFetched++;

                        //Existance
                        var products = serverData.products,
                            mainProduct, secondaryProducts = [];


                        var conditionAllArticlesOfGenericAccessoryLine = (_.filter(products, function(iterableProduct) {
                            return (iterableProduct.accessoryLineId === '0');
                        }).length === products.length);

                        var conditionAtLeastOneArticleOfCurrentAccessoryLine = (_.filter(products, function(iterableProduct) {
                            return (iterableProduct.accessoryLineId === accessoryLineId);
                        }).length > 0);

                        //Retrieving articles only from current catalog
                        products = _.filter(products, function(iterableProduct) {
                            return iterableProduct.catalogId === '1';
                        });

                        var conditionAtLeastOneArticleWithMnemonic1 = (_.filter(products, function(iterableProduct) {
                            return (iterableProduct.mnemonic === 1);
                        }).length > 0);

                        var conditionAllArticlesWithPrice = (_.filter(products, function(iterableProduct) {
                            return ((iterableProduct.price === null) && (iterableProduct.productCode.indexOf('__ND__') !== 0));
                        }).length === 0);

                        if ((conditionAtLeastOneArticleOfCurrentAccessoryLine || conditionAllArticlesOfGenericAccessoryLine) && conditionAtLeastOneArticleWithMnemonic1 && conditionAllArticlesWithPrice) {
                            mainProduct = _.filter(products, function(iterableProduct) {
                                return iterableProduct.mnemonic === 1;
                            })[0];
                            secondaryProducts = _.filter(products, function(iterableProduct) {
                                return iterableProduct.mnemonic !== 1;
                            });

                            if (!(originalPackage instanceof Array)) {
                                if (originalPackage.attributes) {
                                    originalPackage.attributes = _.extend(originalPackage.attributes, mainProduct);
                                    originalPackage.attributes.secondaryProducts = secondaryProducts;
                                } else {
                                    originalPackage = _.extend(originalPackage, mainProduct);
                                    originalPackage.secondaryProducts = secondaryProducts;
                                }
                            } else {
                                originalPackage[i] = _.extend(originalPackage[i], mainProduct);
                                originalPackage[i].secondaryProducts = secondaryProducts;
                            }
                        }

                        if (numberOfArticlesFetched === packagesToFetch.length) {
                            successCallback.apply(successCallbackScope, [currentPackage, successCallbackParameters]);
                        }
                    };

                for (var i = 0, length = packagesToFetch.length; i < length; i++) {
                    this.startServerCall(true, null, this.serviceURL.getProductsURL, {
                        token: window.BticinoS4B.token,
                        idPackageClass: packagesToFetch[i].attributes ? packagesToFetch[i].get('packageClassId') : packagesToFetch[i].packageClassId,
                        accessoryLineId: accessoryLineId,
                    }, prepareDatasAndUpdateRaceCondition, packagesToFetch[i], successCallbackScope);
                }
            }
        },

        getEnabledCategorySystemListByLocalization: function(localization, successCallback, successCallbackParameters, successCallbackScope) {
            var callData = {
                token: window.BticinoS4B.token,
                localization: localization
            },
                returnCategorySystem = function(data) {
                    successCallback.apply(successCallbackScope, [data]);
                };
            this.startServerCall(false, null, this.serviceURL.getEnabledCategorySystemListByLocalizationURL, callData, returnCategorySystem, successCallbackParameters, successCallbackScope);
        },

        getAllCategorySystemList: function(successCallback, successCallbackParameters, successCallbackScope) {
            var callData = {
                token: window.BticinoS4B.token,
                localization: app.UserDatas.branchLocalizationId
            },
                returnCategorySystem = function(data) {
                    successCallback.apply(successCallbackScope, [data, successCallbackParameters]);
                };
            this.startServerCall(false, null, this.serviceURL.getAllCategorySystemListURL, callData, returnCategorySystem, successCallbackParameters, successCallbackScope);
        },

        getDictionary: function(lang, callbackGT, callBackGTScope, callBackGTParameters) {
            var callData = {
                languageCode: lang
            },
                stringId = 'string_id',
                stringTranslation = 'string_translation',

                prepareDictionary = function(data) {
                    data.Dictionary = {};

                    for (var i = 0, length = data.length; i < length; i++) {
                        data.Dictionary[data[i][stringId]] = data[i][stringTranslation];
                    }

                    if (callbackGT) {
                        callbackGT.apply(callBackGTScope, _.union([data.Dictionary], callBackGTParameters));
                    }
                };

            this.startServerCall(true, null, this.serviceURL.getDictionaryURL, callData, prepareDictionary);
        },

        getLanguageListByLocalization: function(localization, callBackLL, callbackLLScope) {
            var callData = {
                localization: localization
            },
                languageListCallback = function(data) {
                    console.log(data);
                };

            if (!callBackLL) {
                this.startServerCall(true, null, this.serviceURL.getLanguageListByLocalizationURL, callData, languageListCallback);
            } else {
                this.startServerCall(true, null, this.serviceURL.getLanguageListByLocalizationURL, callData, callBackLL, [], callbackLLScope);
            }
        },

        getExtendedLanguageList: function(callBackLL, callbackLLScope) {
            var callData = {
                token: window.BticinoS4B.token,
                localization: app.UserDatas.branchLocalizationId
            },
                languageListCallback = function(data) {
                    console.log(data);
                };

            if (!callBackLL) {
                this.startServerCall(true, null, this.serviceURL.getExtendedLanguageListURL, callData, languageListCallback);
            } else {
                this.startServerCall(true, null, this.serviceURL.getExtendedLanguageListURL, callData, callBackLL, [], callbackLLScope);
            }
        },

        getLanguageList: function(callBackLL, callbackLLScope) {
            var callData = {
                token: window.BticinoS4B.token,
            },
                languageListCallback = function(data) {
                    //console.log(data);
                };

            if (!callBackLL) {
                this.startServerCall(false, null, this.serviceURL.getLanguageListURL, callData, languageListCallback);
            } else {
                this.startServerCall(false, null, this.serviceURL.getLanguageListURL, callData, callBackLL, [], callbackLLScope);
            }
        },

        getOptionalPackages: function(systemId, accessoryLineId, successCallback, successCallbackParameters, successCallbackScope) {
            var callData = {
                token: window.BticinoS4B.token,
                accessoryLineId: 0,
                systemId: systemId
            },
                returnPackages = function(data) {
                    successCallback.apply(successCallbackScope, [data, successCallbackParameters]);
                };
            this.startServerCall(true, 'getOptionalPackages', this.serviceURL.getOptionalPackagesBySystemIdURL, callData, returnPackages, successCallbackParameters, successCallbackScope);
        },

        getPackageByIdPackageClass: function(idPackageClass, accessoryLineId, successCallback, successCallbackScope) {
            if (idPackageClass) {
                var callData = {
                    token: window.BticinoS4B.token,
                    accessoryLineId: accessoryLineId,
                    idPackageClass: idPackageClass
                };
                this.startServerCall(true, 'getPackageByIdPackageClass', this.serviceURL.getPackageByIdPackageClassURL, callData, successCallback, successCallbackScope);
            }
        },

        getPackagesByIdWizardChoice: function(idWizardChoice, accessoryLineId, successCallback, successCallbackParameters, successCallbackScope) {
            if (idWizardChoice) {
                var callData = {
                    token: window.BticinoS4B.token,
                    accessoryLineId: window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"),
                    idWizardChoice: idWizardChoice
                },
                    prepareDatas = function(data) {
                        for (var i = 0, length = data.packages.length; i < length; i++) {
                            data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);
                        }

                        successCallback.apply(successCallbackScope, [data, successCallbackParameters]);
                    };
                this.startServerCall(true, null, this.serviceURL.getPackagesByIdWizardChoiceURL, callData, prepareDatas);
            }
        },

        getPackagesByIdWizardChoiceRegardlessAccessoryLine: function(idWizardChoice, successCallback, successCallbackParameters, successCallbackScope) {
            if (idWizardChoice) {
                var callData = {
                    token: window.BticinoS4B.token,
                    idWizardChoice: idWizardChoice
                },
                    prepareDatas = function(data) {
                        for (var i = 0, length = data.packages.length; i < length; i++) {
                            data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);
                        }
                        successCallback.apply(successCallbackScope, [data, successCallbackParameters]);
                    };
                this.startServerCall(true, null, this.serviceURL.getPackagesByIdWizardChoiceRegardlessAccessoryLineURL, callData, prepareDatas);
            }
        },

        getUsersByLocalization: function(localization, callbackGT, callBackGTScope, callBackGTParameters) {
            var callData = {
                token: window.BticinoS4B.token,
                localization: localization
            };

            this.startServerCall(true, 'getUsersByLocalization', this.serviceURL.getUsersByLocalizationURL, callData, callbackGT, callBackGTScope, callBackGTParameters);
        },

        getUser: function(successGetUserCallback, failedGetUserCallback, callbackScope) {
            var callData = {
                token: window.BticinoS4B.token
            };
            if (callData.token) {
                this.startServerCall(false, 'getUser', this.serviceURL.getUserURL, callData, successGetUserCallback, [], callbackScope, failedGetUserCallback, [], callbackScope);
            } else {
                failedGetUserCallback.apply(callbackScope);
            }
        },

        getAccessoryLines: function(successCallback, failedCallback, callbackScope) {
            var callData = {
                token: window.BticinoS4B.token
            };
            if (callData.token) {
                this.startServerCall(false, 'getAccessoryLines', this.serviceURL.getAccessoryLinesURL, callData, successCallback, [], callbackScope, failedCallback, [], callbackScope);
            } else {
                failedCallback.apply(callbackScope);
            }
        },

        getAllAccessoryLines: function(successCallback, failedCallback, callbackScope) {
            var callData = {
                token: window.BticinoS4B.token
            };
            if (callData.token) {
                this.startServerCall(true, null, this.serviceURL.getAllAccessoryLinesURL, callData, successCallback, [], callbackScope, failedCallback, [], callbackScope);
            } else {
                failedCallback.apply(callbackScope);
            }
        },

        getCatalogueByBranch: function(successCallback, failedCallback, callbackScope) {
            var callData = {
                token: window.BticinoS4B.token
            };
            if (callData.token) {
                this.startServerCall(true, null, this.serviceURL.getCatalogueByBranchURL, callData, successCallback, [], callbackScope, failedCallback, [], callbackScope);
            } else {
                failedCallback.apply(callbackScope);
            }
        },

        login: function(username, password, flagRemember, successLoginCallback, failedLoginCallback, callbackScope) {
            var callData = {
                user: username,
                password: password,
                remember: flagRemember
            };

            this.startServerCall(false, 'login', this.serviceURL.loginURL, callData, successLoginCallback, [], callbackScope, failedLoginCallback, [], callbackScope);
        },

        loginSSO: function(username, password, flagRemember, successLoginCallback, failedLoginCallback, callbackScope) {
            var callData = {
                user: username,
                password: password,
                remember: flagRemember
            };

            this.startServerCall(false, 'loginSSO', this.serviceURL.loginSSOURL, callData, successLoginCallback, [], callbackScope, failedLoginCallback, [], callbackScope);
        },

        logout: function(successLogoutCallback, failedLogoutCallback, callbackScope) {
            var callData = {
                token: window.BticinoS4B.token
            };

            this.startServerCall(true, 'logout', this.serviceURL.logoutURL, callData, successLogoutCallback, [], callbackScope, failedLogoutCallback, [], callbackScope);
        },

        setCurrentLanguage: function(language, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                languageId: language
            };
            if (language) {
                this.startServerCall(false, 'setCurrentLanguage', this.serviceURL.setCurrentLanguageURL, callData, successCallback);
            }
        },

        setCurrentLocalization: function(localization, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                localizationId: localization
            };

            if (localization) {
                this.startServerCall(false, 'setCurrentLocalization', this.serviceURL.setCurrentLocalizationURL, callData, successCallback);
            }
        },

        setCatalogueByBranch: function(catalogCode, flagMain, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                CatalogCode: Number(catalogCode),
                flagMain: flagMain !== 0 ? 1 : 0
            };

            if (catalogCode) {
                this.startServerCall(true, null, this.serviceURL.setCatalogueByBranchURL, callData, successCallback);
            }
        },

        setCategorySystemByLocalization: function(systemCode, enabled, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                systemCode: systemCode,
                localizationCode: app.UserDatas.branchLocalizationId,
                enabled: enabled ? 1 : 0
            };

            if (systemCode) {
                this.startServerCall(true, null, this.serviceURL.setCategorySystemByLocalizationURL, callData, successCallback);
            }
        },

        setAccessoryLinesByLocalization: function(accessoryLineCode, enabled, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                localizationCode: app.UserDatas.branchLocalizationId,
                accessoryLineCode: accessoryLineCode,
                enabled: enabled ? 1 : 0
            };

            if (accessoryLineCode) {
                this.startServerCall(true, null, this.serviceURL.setAccessoryLinesByLocalizationURL, callData, successCallback);
            }
        },

        setLocalizationLanguage: function(language, localization, enabled, setAsDefault, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                languageCode: language,
                localization: localization,
                enabled: enabled ? 1 : 0,
                setAsDefault: setAsDefault
            };

            if ((localization) && (language)) {
                this.startServerCall(true, null, this.serviceURL.setLocalizationLanguageURL, callData, successCallback);
            }
        },

        setUser: function(userId, user, password, roles, idBranch, code, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                userId: userId,
                user: user,
                password: password,
                roles: roles,
                idBranch: idBranch,
                code: code
            };

            if (user) {
                this.startServerCall(true, 'setUser', this.serviceURL.setUserURL, callData, successCallback);
            }
        },

        setPackageClassAccessoryLineLocalization: function(packageClassCode, accessoryLineCode, enabled, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                packageClassCode: packageClassCode,
                accessoryLineCode: accessoryLineCode,
                localizationCode: app.UserDatas.branchLocalizationId,
                enabled: enabled ? 1 : 0
            };

            if ((packageClassCode) && (accessoryLineCode)) {
                this.startServerCall(true, null, this.serviceURL.setPackageClassAccessoryLineLocalizationURL, callData, successCallback);
            }
        },

        getProjectList: function(wiringAccessoryLineCode, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                wiringAccessoryLineCode: wiringAccessoryLineCode
            };
            this.startServerCall(false, null, this.serviceURL.getProjectListURL, callData, successCallback);
        },

        getGroupProjectList: function(wiringAccessoryLineCode, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                wiringAccessoryLineCode: wiringAccessoryLineCode
            };
            this.startServerCall(false, null, this.serviceURL.getGroupProjectListURL, callData, successCallback);
        },

        loadProject: function(successCallback) {

        },

        updateProject: function(name, projectId, projectContent, wiringAccessoryLineCode, ticket, note, successCallback) {
            var callData = {
                    token: window.BticinoS4B.token,
                    name: name,
                    projectId: projectId,
                    content: JSON.stringify(projectContent),
                    wiringAccessoryLineCode: wiringAccessoryLineCode,
                    ticket: ticket,
                    note: note
                };
            this.startServerCall(false, null, this.serviceURL.updateProjectURL, callData, successCallback);
        },

        duplicateProject: function(projectID, successCallback) {
            var callData = {
                    token: window.BticinoS4B.token,
                    projectId: projectID
                    };
            this.startServerCall(false, null, this.serviceURL.duplicateProjectURL, callData, successCallback);
        },

        saveProject: function(name, projectContent, accessoryLineCode, ticket, note, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                name: name,
                content: JSON.stringify(projectContent),
                wiringAccessoryLineCode: accessoryLineCode,
                ticket: ticket,
                note: note
            };
            this.startServerCall(true, null, this.serviceURL.saveProjectURL, callData, successCallback);
        },

        deleteProject: function(ProjectToDeleteID, successCallback) {
            var callData = {
                token: window.BticinoS4B.token,
                projectId: ProjectToDeleteID
            };
            this.startServerCall(true, null, this.serviceURL.deleteProjectURL, callData, successCallback);
        },

        importPriceList: function(idPriceList, successCallback, callbackScope) {
            var callData = {
                token: window.BticinoS4B.token,
                fileName: idPriceList + '.file'
            };

            if (idPriceList) {
                this.startServerCall(true, 'importPriceList', this.serviceURL.importPriceListURL, callData, successCallback, [], callbackScope);
            }
        },

        getPriceListItems: function(idPriceList, successCallback, callbackScope) {
            var callData = {
                token: window.BticinoS4B.token,
                idpricelist: idPriceList
            };

            if (idPriceList) {
                this.startServerCall(true, 'getPriceListItems', this.serviceURL.getPriceListItemsURL, callData, successCallback, [], callbackScope);
            }
        },

        publicPriceList: function(idPriceList, successCallback, callbackScope) {
            var callData = {
                token: window.BticinoS4B.token,
                idpricelist: idPriceList
            };

            if (idPriceList) {
                this.startServerCall(true, 'publicPriceList', this.serviceURL.publicPriceListURL, callData, successCallback, [], callbackScope);
            }
        },

        getPackagesByLocalization: function(successCallback, failedCallback, callbackScope) {
            var callData = {
                token: window.BticinoS4B.token,
                systemId: app.systemId
            };
            if (callData.token) {
                this.startServerCall(true, null, this.serviceURL.getPackagesByLocalizationURL, callData, successCallback, [], callbackScope, failedCallback, [], callbackScope);
            } else {
                failedCallback.apply(callbackScope);
            }
        },

        downloadEmptyTemplatePriceList: function(successCallback) {
            var callData = {
                token: window.BticinoS4B.token
            };

            this.startServerCall(true, 'downloadEmptyTemplatePriceList', this.serviceURL.downloadEmptyTemplatePriceListURL, callData, successCallback);
        },

        downloadFullTemplatePriceList: function(successCallback) {
            var callData = {
                token: window.BticinoS4B.token
            };

            this.startServerCall(true, 'downloadFullTemplatePriceList', this.serviceURL.downloadFullTemplatePriceListURL, callData, successCallback);
        },

        forwardProjectByEmail: function(emailTo, subject, body, successCallback, failedCallback, callbackScope){
            var callData = {
                token: window.BticinoS4B.token,
                sender: window.BticinoS4B.mailManager.sender,
                smtp: window.BticinoS4B.mailManager.smtp,
                emailTo : emailTo,
                subject: subject,
                body: body
            };

            if (callData.sender || callData.smtp || callData.emailTo || callData.subject || callData.body)  {
                this.startServerCall(true, 'forwardProjectByEmail', this.serviceURL.ForwardProjectByEmailURL, callData, successCallback, [], callbackScope, failedCallback, [], callbackScope);
            }
        }
    });

    return WizardServices;
});